import React, {Component,Fragment} from 'react';
import {Upload, Icon, Modal,Form} from 'antd';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';

const mapStateToProps = (rootState, ownProps) => ({
    _state: rootState.transfer,
  });
  
// @ts-ignore
@connect(mapStateToProps)
class UploadItems extends Component {
    state = {
        previewVisible: false,
        previewImage: '',
        length: 0
    };

    componentWillReceiveProps(nextProps, nextContext) {
        let len = 0;
        nextProps.soureData.forEach(el=>{
            if(el.url){
                len++;
            }
        })
        this.setState({
            length: len
        })
    }
    //监测上传图片
    handleChange = (e,index,required) => {
        const {typeName} = this.props;
        const {length} = this.state
        let file = e.target.files[0];
        let url;
        if (window.createObjectURL != undefined) {
            url = window.createObjectURL(file);
        } else if (window.URL != undefined) {
            url = window.URL.createObjectURL(file);
        } else if (window.webkitURL != undefined) {
            url = window.webkitURL.createObjectURL(file);
        }
        this.props.upload(url,file,index,typeName,required,length);
    };

    // 预览
    prewImg = url=>{
        this.setState({
            previewVisible: true,
            previewImage: url
        })
    }

    hideModal = ()=>{
        this.setState({
            previewVisible: false
        })
    }

    // 删除
    delItem = index=>{
        const {typeName} = this.props;
        this.props.delItem(typeName,index)
    }

    render() {
        const { soureData, typeName, desc, required, count,keyValue,transferType,picTransferType} = this.props;
        const {previewVisible,previewImage,length} = this.state;
        const _this = this
        const { getFieldDecorator } = _this.props.form;
        return (
            <Fragment>
                <p className="desc">{required?<span style={{color:'#FF571A',marginRight:10}}>*</span>:''}{desc} <span style={{color:'#999999'}}>({soureData.length}/6)</span></p>
                <ul className="wrap">
                    {soureData.length > 0 && soureData.map((el, index) => {
                        if(el.url){
                            return <li key={index}  className='upload-items'>
                            <label className='upload-item'>
                                <img src={el.url} alt=""/>
                            </label>
                            <div className="upload-icon">
                                <Icon type="eye" onClick={()=>this.prewImg(el.url)}/>  
                            </div>
                            <div className="upload-icon-eye">
                                <Icon type="close-circle" theme="filled" onClick={()=>this.delItem(index)}/>
                            </div>
                        </li>  
                        }
                    })}
                    {soureData.length < count && <li>
                        <label className='upload-item' htmlFor={typeName}>
                            <Icon type="plus"/>
                        </label>
                        <input type="file" className="hide" id={typeName} accept="image/*" onChange={e=>this.handleChange(e,keyValue,required)} onClick={(event)=> { event.target.value = null }}/>
                    </li>}
                </ul>

                <Modal
                    visible={previewVisible}
                    title={null}
                    footer={null}
                    onCancel={this.hideModal}
                >
                    <img alt="example" style={{ width: '100%',height: '100%' }} src={previewImage} />
                </Modal>
            </Fragment>

        );
    }
}
const UploadItem = Form.create()(UploadItems);
export default UploadItem;


